import { render, staticRenderFns } from "./EditarDerivacionImagen.vue?vue&type=template&id=50efb1d4"
import script from "./EditarDerivacionImagen.vue?vue&type=script&lang=js"
export * from "./EditarDerivacionImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports